import "./bootstrap";

// This is but a hack for macOS / iOS based browsers-
// sadly this is still a thing... https://zellwk.com/blog/inconsistent-button-behavior/
document.addEventListener("click", function(event) {
    try {
        if (event.target.matches("button")) {
            event.target.focus();
        } else if (
            event.target.parentNode &&
            event.target.parentNode.matches("button")
        ) {
            event.target.parentNode.focus();
        }
    } catch (error) {}
});

const intersect = function(o1, o2) {
    const [k1, k2] = [Object.keys(o1), Object.keys(o2)];
    const [first, next] = k1.length > k2.length ? [k2, o1] : [k1, o2];
    return first.filter(k => k in next);
};

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
